module.exports = __webpack_public_path__ + "f9be161b23cad108445b80c1b042d3cb.svg";